import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { AfterContentInit, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, firstValueFrom, throwError } from 'rxjs';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { EsimLocationDTO } from 'src/app/core/models/system/webbing/esim-location.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { MapSimLocationsComponent } from 'src/app/shared/widget-no-formsmodalmodule/map-sim-locations/map-sim-locations.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-map-company-modal-form',
  templateUrl: './map-company-modal-form.component.html',
  styleUrls: ['./map-company-modal-form.component.scss']
})

export class MapCompanyModalFormComponent implements AfterContentInit, AfterViewInit, OnDestroy, OnInit {

  @Input() disableManageSimForm  : boolean | undefined;
  @Input() embeddedFormMode      : boolean | undefined;
  @Input() initialInviewCompanyId: number  | undefined;
    
  @ViewChild('manageEsimModalForm',        { static: false }) manageEsimModalForm!       : ManageEsimModalFormComponent;
  @ViewChild('mapCompanyModalFormContent', { static: false }) mapCompanyModalFormContent!: TemplateRef<void>;
  @ViewChild('mapSimLocations',            { static: false }) mapSimLocations!           : MapSimLocationsComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  // get superHierarchyEnabled     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownCompanySuperHierarchyEnabled, false); }
  get superHierarchyEnabled     () { return false; }

  private companyMapModalFormRef!      : NgbModalRef;
  private curUser                      : SystemUserDTO;
  private manageEsimFormIsOpen         : boolean=false;

  public breadCrumbItems!              : Array<{}>;
  public currProduct                   : IdAndDescriptionDTO | undefined;
  public curUserID                     : number | undefined;
  public dataLoaded                    : boolean=false;
  public featureEnabledLocationServices: boolean=false;
  public filterCompanyID               : number | undefined;
  public formSubmitted                 : boolean=false;
  public formTitle                     : string | undefined = "Location Awareness";
  public gotIccid                      : boolean=false;
  public locationDataLoaded            : boolean=false;
  public locationServicesFeatureGuid   : string =  AccessGuids.ChargeableFeatureLocationServices;
  public selectedIccid                 : string | undefined;
  public showFilters                   : boolean=true;
  public sureSimDevice                 : DeviceDTO | undefined;
  public sureSimLocationData           : EsimLocationDTO | undefined;
  public timelineForm!                 : UntypedFormGroup;
  public todayUsageTotalSymbol         : string | undefined;
  public useFullPage                   : boolean=true;
 
  constructor(
    private authenticationService          : AuthenticationService,
    private configSystemService            : ConfigSystemService,
    private dropdownService                : DropdownService,
    private exceptionsService              : ExceptionsService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private ordersService                  : OrdersService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.enableFeatures(); 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterContentInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy() {
    try {
      this.unsubscribeAllConnections();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Features
  
  public async enableFeatures(): Promise<void> {
    try {
      await this.enableFeatureLocationServices();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async enableFeatureLocationServices(): Promise<void> {
    try {
      const data=await firstValueFrom(this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.curUser?.companyId ?? -1, AccessGuids.ChargeableFeatureLocationServices)
                       .pipe(
                         catchError((error) => {
                           return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                         })
                       )
      );

      this.featureEnabledLocationServices=data.result;
      if (this.featureEnabledLocationServices) {
        this.filterCompanyID =this.curUser.companyId;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public unsubscribeAllConnections(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      this.unsubscribeAllConnections();
      this.companyMapModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async companyDropDownOnChange(companyID: number) {
    try {
      this.filterCompanyID=!this.superHierarchyEnabled &&
                           (companyID==null || 
                            companyID==undefined ||
                            companyID<=0)
                           ?
                           0 - this.curUser.companyId
                           :
                           companyID;
      
      this.dropdownService.trackerCompanyId=this.filterCompanyID;

      this.mapSimLocations.companyId = this.filterCompanyID;
      this.mapSimLocations.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
